// src/redux/reducers/cartReducer.ts
import { UPDATE_CART_QUANTITY } from './actions';
import { UpdateCartQuantityAction } from './types';

export interface CartState {
  quantity: number;
}

const initialState: CartState = {
  quantity: 0
};

type CartActionTypes = UpdateCartQuantityAction;

const cartItemsMvp = (
  state = initialState,
  action: CartActionTypes
): CartState => {
  switch (action.type) {
    case UPDATE_CART_QUANTITY:
      return {
        ...state,
        quantity: action.quantity
      };
    default:
      return state;
  }
};

export default cartItemsMvp;
